import i18n from 'i18next';
import deTranslation from './de/translation.json';
import enTranslation from './en/translation.json';
import { initReactI18next } from 'react-i18next';

export const resources = {
    en: {
        translation: enTranslation,
    },
    de: {
        translation: deTranslation,
    },
} as const;

i18n.use(initReactI18next).init({
    lng: 'de',
    resources,
});
